module.exports = __webpack_public_path__ + "img/cash.c07cd33f.svg";